import { useState } from "react";
import { useLocation } from "react-router-dom";
import DynamicMaster from "../../Components/DynamicMaster/DynamicMaster";
import { useAuthStore } from "../../AuthStore/AuthStore";


export default function SectionMaster() {

  // const { userId,currentRoleId,permissionRecord } = useAuthStore();


  return (
    <>
      <DynamicMaster id={7} dashboardId={7} />
    </>
  );



}